module.exports = "/shifts/components/shiftTemplatePreviewComponent-cee3f4.html";